import styled from 'styled-components';
import flexGen from 'utils/flexGen';

export const StyledPerspectiveWrapper = styled.div`
  ${flexGen('center', 'center', 'row')}
  width: 100vw;
  height: 100vh;
`;
